import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { CollectionTileClickImpressionContext } from "@faire/retailer/hooks/CollectionTileImpression/CollectionTileClickImpressionContext";
import { CollectionTileViewImpressionProvider } from "@faire/retailer/hooks/CollectionTileImpression/CollectionTileViewImpressionProvider";
export var CollectionTileImpressionProvider = function(param) {
    var children = param.children, contextToken = param.contextToken, requestId = param.requestId, screenContext = param.screenContext, containerContext = param.containerContext;
    var value = {
        contextToken: contextToken,
        requestId: requestId,
        screenContext: screenContext,
        containerContext: containerContext
    };
    return /*#__PURE__*/ _jsx(CollectionTileViewImpressionProvider, _object_spread_props(_object_spread({}, value), {
        children: /*#__PURE__*/ _jsx(CollectionTileClickImpressionContext.Provider, {
            value: value,
            children: children
        })
    }));
};
